<template>

 
    <v-navigation-drawer
      absolute
      permanent
      app
      color='primary'      
      :mini-variant.sync="mini"
      dark
      
    >
     <v-card elevation="12" height="100%">
    <v-row class="justify-center">
        <v-btn
          icon
          @click.stop="mini = !mini"
        >
          <v-icon v-if="mini==false" large class="ma-2 pa-2">mdi-chevron-left</v-icon>
           <v-icon v-else large class="ma-2 pa-2">mdi-chevron-right</v-icon>
        </v-btn>
    </v-row>
      <v-divider class="ma-2"></v-divider>
      

      <v-list dense>
        <v-list-item
          v-for="item in items2"
          :key="item.title"
          router :to='item.route'
        >
          <v-list-item-icon>
            <v-icon class="orange--text text--lighten-3">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title><h3 class="yellow--text text--lighten-3">{{ item.title }}</h3></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-row>
       <langSwitcher/>
      </v-row>
      </v-card>
    </v-navigation-drawer>
    
</template>


<script>
// eslint-disable-next-line no-unused-vars
import $i18n from '@/i18n'
import langSwitcher from '@/components/langSwitcher'


  export default {
    components:{langSwitcher},

    data () {
      //const lang = localStorage.getItem('lang') || 'en';
      return {
        
        mini:true,
      }
    },
    computed:{
      items2(){
         var items2= [
          { title: $i18n.t('leftMenu.titleMenuSellscreen'), icon: 'mdi-currency-usd', route:`/${$i18n.locale}/sellScreen`  },
          { title: $i18n.t('leftMenu.titleMenuInventory'), icon: 'mdi-package-variant', route:`/${$i18n.locale}/inventory` },
          { title: $i18n.t('leftMenu.titleMenuProducts'), icon: 'mdi-penguin', route:`/${$i18n.locale}/products` },          
          { title: $i18n.t('leftMenu.titleMenuClients'), icon: 'mdi-emoticon-excited-outline',route:`/${$i18n.locale}/clients` },
          { title: $i18n.t('leftMenu.titleMenuSales'), icon: 'mdi-cart-arrow-up', route:`/${$i18n.locale}/sales` },
          { title: $i18n.t('leftMenu.titleMenuBuys'), icon: 'mdi-cart-arrow-down', route:`/${$i18n.locale}/compras`  },
          { title: $i18n.t('leftMenu.titleMenuBenefits'), icon: 'mdi-cash-multiple', route:`/${$i18n.locale}/beneficios`  },
          { title: $i18n.t('leftMenu.titleMenuDatabase'), icon: 'mdi-folder', route:`/${$i18n.locale}/database`  },
        ]
         return items2
        }
    },
    methods:{
      changeLang(value){
        //localStorage.setItem('lang',event.target.value);
        //console.log(value)
        this.$i18n.locale=value
        //window.location.reload;
      }
    },
  }
</script>